import { Button, Tabs, Typography } from "antd";
import TinymceEditor from "./TinymceEditor";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import './report-editor.css'
import { useUser } from "../context/UserContext";
import _ from "lodash";
import { useModal } from "../context/ModalContext";
import ReportPDFPreview from "../../app/report/ReportPDFPreview";

const { TabPane } = Tabs;

export default function ReportEditor({ defaultReportContent, onBulgular, onSonuc, onKarsilastirma, onTeknik, editable = true }) {
    const { t } = useTranslation();
    const { dictionary } = useUser()
    const { openModal, closeModal } = useModal()
    const [height, setHeight] = useState(() => {
        const savedHeights = localStorage.getItem('report-editor-heights');
        return savedHeights ? JSON.parse(savedHeights) : {
            bulgular: 40,
            sonuc: 40,
            teknik: 20,
            karsilastirma: 20
        };
    })

    const dragging = useRef({
        key: null,
        startY: 0,
        startHeight: 0
    });

    useEffect(() => {
        localStorage.setItem('report-editor-heights', JSON.stringify(height));
    }, [height]);

    const handleMouseDown = (e, key) => {
        dragging.current = {
            key,
            startY: e.clientY,
            startHeight: height[key]
        };
        e.preventDefault();

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    const handleMouseMove = (e) => {
        if (!dragging.current.key) return;

        const deltaY = e.clientY - dragging.current.startY;
        // Convert px change to vh change approx. This isn't perfect but works for general resizing.
        // Assuming window height.
        const deltaVh = (deltaY / window.innerHeight) * 100;

        const newHeight = Math.max(10, dragging.current.startHeight + deltaVh); // Min 10vh

        setHeight(prev => ({
            ...prev,
            [dragging.current.key]: newHeight
        }));
    };

    const handleMouseUp = () => {
        dragging.current.key = null;
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
    };

    const ResizeHandle = ({ onMouseDown }) => (
        <div
            onMouseDown={onMouseDown}
            style={{
                height: '10px',
                width: '100%',
                cursor: 'row-resize',
                backgroundColor: '#f0f0f0',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderBottom: '1px solid #d9d9d9',
                borderTop: '1px solid #d9d9d9'
            }}
        >
            <div style={{ width: 40, height: 4, borderRadius: 2, backgroundColor: '#ccc' }} />
        </div>
    );

    return (
        <>
            <Tabs defaultActiveKey={'1'}>
                <TabPane tab={'Rapor'} key={'1'}>
                    <div style={{}}>
                        <div style={{ width: '100%', backgroundColor: '#eaeaea', paddingLeft: 8 }}>
                            <Typography.Title level={5}>Bulgular</Typography.Title>
                        </div>
                        {
                            editable && (
                                <>
                                    <TinymceEditor
                                        dictionary={dictionary}
                                        height={`${height.bulgular}vh`}
                                        value={defaultReportContent?.Bulgular}
                                        handleChange={(data) => {
                                            onBulgular && onBulgular(data)
                                        }}
                                    />
                                    <ResizeHandle onMouseDown={(e) => handleMouseDown(e, 'bulgular')} />
                                </>
                            )
                        }

                        <div style={{ width: '100%', backgroundColor: '#eaeaea', paddingLeft: 8, marginTop: 16 }}>
                            <Typography.Title level={5}>Sonuç ve Öneriler</Typography.Title>
                        </div>
                        {
                            editable && (
                                <>
                                    <TinymceEditor
                                        dictionary={dictionary}
                                        height={`${height.sonuc}vh`}
                                        value={defaultReportContent?.SonucVeOneriler}
                                        handleChange={(data) => {
                                            onSonuc && onSonuc(data)
                                        }}
                                    />
                                    <ResizeHandle onMouseDown={(e) => handleMouseDown(e, 'sonuc')} />
                                </>
                            )
                        }
                    </div>
                </TabPane>

                <TabPane tab={'Diğer'} key={'2'}>
                    <div style={{ width: '100%', backgroundColor: '#eaeaea', paddingLeft: 8 }}>
                        <Typography.Title level={5}>Teknik</Typography.Title>
                    </div>
                    {
                        editable && (
                            <>
                                <TinymceEditor
                                    dictionary={dictionary}
                                    height={`${height.teknik}vh`}
                                    value={defaultReportContent?.Teknik}
                                    handleChange={(data) => {
                                        onTeknik && onTeknik(data)
                                    }}
                                />
                                <ResizeHandle onMouseDown={(e) => handleMouseDown(e, 'teknik')} />
                            </>
                        )
                    }

                    <div style={{ width: '100%', backgroundColor: '#eaeaea', paddingLeft: 8, marginTop: 16 }}>
                        <Typography.Title level={5}>Karşılaştırma</Typography.Title>
                    </div>
                    {
                        editable && (
                            <>
                                <TinymceEditor
                                    dictionary={dictionary}
                                    height={`${height.karsilastirma}vh`}
                                    value={defaultReportContent?.Karsilastirma}
                                    handleChange={(data) => {
                                        onKarsilastirma && onKarsilastirma(data)
                                    }}
                                />
                                <ResizeHandle onMouseDown={(e) => handleMouseDown(e, 'karsilastirma')} />
                            </>
                        )
                    }
                </TabPane>
            </Tabs>
        </>
    )
}
